// extracted by mini-css-extract-plugin
export default {"main":"qcUSq__ZNX7mkS4mbvTQ","actions":"KlsQJvHRmMM5u5J7AgNS","alternativeSideId":"wEAuBxMFrv9Qv6hMbQrc","switchDocuments":"QAiFgmfSeRVvvZlJN49w"};